import { InstructorValue } from './instructor.value';

export class InstructorValueDto {
    firstName: string;
    lastName: string;
    degree?: string;
    university?: string;
    mediaImageId?: string | null;

    constructor(data: InstructorValue) {
        this.firstName = data.firstName;
        this.lastName = data.lastName;

        if (data.degree !== undefined && data.degree !== '') {
            this.degree = data.degree;
        }
        if (data.university !== undefined && data.university !== '') {
            this.university = data.university;
        }

        // Only send mediaImageId if changed from original
        const originalMediaStr = data.originalMediaImageId != null ? String(data.originalMediaImageId) : null;
        if (data.mediaImageId !== undefined && data.mediaImageId !== originalMediaStr) {
            this.mediaImageId = data.mediaImageId;
        }
    }
}
